module.exports = __webpack_public_path__ + "ccb8ead051527772f230469de83dd4a9.jpg";